import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { grey1 } from 'approot/shared/styles/colours.style';
import { boxShadowBlack12 } from 'approot/shared/styles/borders.style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { PrimaryButton } from 'approot/shared/styles/buttons';
import { SecondaryButton } from 'approot/shared/styles/buttons/secondary-button.style';
import {
  ACTIVITY_BUILDER_DRAWER_BREAKPOINT,
  ACTIVITY_BUILDER_SETTINGS_WIDTH,
} from '../activity-builder.constants';
import {
  PRESENT_DRAWER_WIDTH,
  PRESENT_MENU_BUTTON_Z_INDEX,
} from './activity-builder-present.constants';
import { fontWeightMedium } from 'approot/shared/styles/typography.style';

export const Presentation = styled.div`
  overflow: auto;
  background-color: ${grey1};
`;

type PresentationCanvasProps = {
  $isDrawerActive?: boolean;
  $isDrawerDetailsActive?: boolean;
};

export const PresentationCanvas = styled.main<PresentationCanvasProps>`
  min-height: 100vh;
  position: relative;
  ${({ $isDrawerActive }) =>
    $isDrawerActive &&
    `
      margin-right: ${rem(ACTIVITY_BUILDER_SETTINGS_WIDTH)};
    `}

  ${ACTIVITY_BUILDER_DRAWER_BREAKPOINT} {
    ${({ $isDrawerDetailsActive }) =>
      $isDrawerDetailsActive &&
      `
          margin-right: ${rem(
            ACTIVITY_BUILDER_SETTINGS_WIDTH + PRESENT_DRAWER_WIDTH
          )};
      `}
  }
`;

export const PresentationCanvasInner = styled.div`
  display: flex;
  justify-content: center;
`;

export const PresentBottomControls = styled.div`
  display: flex;
  gap: ${rem(spacing16)};
  bottom: ${rem(spacing16)};
  left: ${rem(spacing16)};
  position: fixed;
  z-index: ${PRESENT_MENU_BUTTON_Z_INDEX};
`;

export const ActivityBuilderPresentNext = styled(PrimaryButton)`
  min-width: auto;
`;

export const ActivityBuilderPresentMenu = styled(SecondaryButton)`
  ${boxShadowBlack12}
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: ${rem(40)} ${rem(40)} 0 0;
  font-weight: ${fontWeightMedium};
  font-size: ${rem(20)};
  position: fixed;
  right: -${rem(30)};
  height: ${rem(60)};
  width: ${rem(116)};
  transform: rotate(270deg);
  top: ${rem(80)};
`;
